// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"OT-z","categoryName":"PT-z","categoryNameSearchHeader":"QT-z","categoryContent":"RT-z","bottomAligned":"ST-z","image":"TT-z","imageNoBackground":"UT-z"};